import styled from "styled-components";

export const ServicesList = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "1rem",
});
